// src/components/QRCardComponent.jsx - Componente de código QR para tarjeta de presentación
import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Download as DownloadIcon,
  ContentCopy as CopyIcon
} from '@mui/icons-material';

const QRCardComponent = ({ userId, userName }) => {
  const qrRef = useRef(null);
  
  // URL de la tarjeta de presentación
  const cardUrl = `${window.location.origin}/tarjeta/${userId}`;

  // Descargar QR como imagen
  const handleDescargarQR = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `qr-tarjeta-${userName?.replace(/\s+/g, '-').toLowerCase() || 'usuario'}.png`;
      link.href = url;
      link.click();
    }
  };

  // Copiar URL al portapapeles
  const handleCopiarURL = () => {
    navigator.clipboard.writeText(cardUrl);
    // Aquí podrías mostrar un snackbar o toast con confirmación
    alert('¡URL copiada al portapapeles!');
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      p: 2
    }}>
      {/* Contenedor del QR */}
      <Box 
        ref={qrRef}
        sx={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(156, 39, 176, 0.15)',
          mb: 2,
          position: 'relative',
          border: '3px solid rgba(156, 39, 176, 0.2)'
        }}
      >
        <QRCodeCanvas
          value={cardUrl}
          size={180}
          level="H"
          includeMargin={false}
          imageSettings={{
            src: "", // Aquí puedes poner el logo de Alianza Social si tienes la URL
            height: 40,
            width: 40,
            excavate: true,
          }}
        />
        
        {/* Logo overlay en el centro (opcional) */}
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 50,
          height: 50,
          backgroundColor: 'white',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          fontSize: '1.5rem'
        }}>
          ⭐
        </Box>
      </Box>
      
      <Typography variant="caption" color="text.secondary" textAlign="center" sx={{ mb: 2, maxWidth: '250px' }}>
        Escanea este código para acceder a la tarjeta de presentación digital
      </Typography>
      
      {/* Botones de acción */}
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <Tooltip title="Descargar QR" arrow>
          <IconButton
            onClick={handleDescargarQR}
            sx={{
              backgroundColor: 'rgba(156, 39, 176, 0.1)',
              color: '#9C27B0',
              '&:hover': {
                backgroundColor: 'rgba(156, 39, 176, 0.2)'
              }
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Copiar URL" arrow>
          <IconButton
            onClick={handleCopiarURL}
            sx={{
              backgroundColor: 'rgba(30, 136, 229, 0.1)',
              color: '#1E88E5',
              '&:hover': {
                backgroundColor: 'rgba(30, 136, 229, 0.2)'
              }
            }}
          >
            <CopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
      
      {/* Botón para ver tarjeta */}
      <Button
        variant="outlined"
        fullWidth
        sx={{
          borderRadius: '12px',
          borderColor: '#9C27B0',
          borderWidth: '2px',
          color: '#9C27B0',
          fontWeight: 600,
          '&:hover': {
            borderWidth: '2px',
            borderColor: '#7B1FA2',
            backgroundColor: 'rgba(156, 39, 176, 0.04)'
          }
        }}
        onClick={() => {
          window.open(cardUrl, '_blank');
        }}
      >
        Ver Tarjeta de Presentación
      </Button>
    </Box>
  );
};

export default QRCardComponent;